import { fetchWithState, getFetchedJSON } from '~/misc/fetch';


export const getCityRatio = (getState, truckType) => {
	return fetchWithState(getState, {
		url: `/tl/shipment/state/count?prompt=false&equipment=${truckType}`,
		method: 'GET',
	}, false).then(getFetchedJSON);
}



export const getCapacityRatio = (getState, data) => {
	return fetchWithState(getState, {
		url: `/tl/v2/shipment/state/count`,
		method: 'POST',
		body: {
			state: data.state
		},
	}, false).then(getFetchedJSON);
}




// WEBPACK FOOTER //
// ./src/api/ratio.js